import ProfileHeader from "@/components/features/user-profile/profile-header";
import { VouchingForm } from "@/components/forms/vouching-form";
import { Separator } from "@/components/ui/separator";
import type { ProfileViewModel } from "@/lib/types";
import { useOutletContext } from "react-router";

const InitiateVouch = () => {
  const profile = useOutletContext<ProfileViewModel>();

  return (
    <section className="relative z-10 mx-auto flex max-w-4xl  flex-1 flex-col  gap-5  px-6 py-24 sm:gap-10">
      <ProfileHeader profile={profile} label="About you" />
      <Separator />

      <div className="animate-screen flex flex-col items-start gap-5">
        {/* <VouchFormHeader title="A few quick questions" /> */}
        <VouchingForm voucheeName={profile?.FirstName} />
      </div>
    </section>
  );
};

export default InitiateVouch;
